export function stripNullBytes(raw: string): string {
  return raw.replaceAll("\0", "");
}
